import React from "react";
import { Reveal, Overline } from "./Motion";
import { SmartImage } from "./SmartImage";
import { GALLERY } from "@/data/cafe";

export default function Gallery() {
  return (
    <section id="gallery" className="bg-[#1A1514] py-24 md:py-32" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <Overline>Gallery</Overline>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F5F2EB] mt-4 font-medium">
            Moments at <span className="italic text-[#1C7C54]">Teaavi</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 mt-14">
          {GALLERY.map((g, i) => (
            <Reveal key={g.label} delay={(i % 2) * 0.1} className={g.span}>
              <div className="relative overflow-hidden rounded-sm group h-64 md:h-80" data-testid={`gallery-${i}`}>
                <SmartImage src={g.image} alt={g.label} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-[#1A1514]/20 group-hover:bg-[#1A1514]/50 transition-colors duration-500" />
                <div className="absolute inset-x-0 bottom-0 p-5 flex items-center justify-between translate-y-2 opacity-90 group-hover:translate-y-0 transition-transform duration-500">
                  <span className="font-display text-2xl text-[#F5F2EB]">{g.label}</span>
                  <span className="overline text-[#F5F2EB]/70">0{i + 1}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
